/**
 * ApiError — typed error thrown by fetchApi for non-OK responses.
 *
 * Lives in its own module (not client.ts) so components and tests can import
 * it without pulling in client.ts's module-scope `import.meta.env` read,
 * which ts-jest's CommonJS transform can't parse (same pattern as
 * apiBaseUrl.ts / reviewShareUrl.ts / devBuild.ts). client.ts re-exports it,
 * so existing imports keep working.
 */
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public code?: string,
    public details?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
